<script setup lang="ts">
import { defineAsyncComponent } from '#imports'

const YscLabel = defineAsyncComponent(() => import('./YscLabel.vue'))

interface Props {
  disabled?: boolean
  required?: boolean
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  required: false,
})
</script>

<template>
  <div>
    <YscLabel
      v-if="$slots.default"
      v-bind="$attrs"
      :disabled="disabled"
      :required="required"
      class="inline-block"
      :class="{ 'mb-2': !$slots.description }"
    >
      <slot name="default" />
    </YscLabel>

    <p
      v-if="$slots.description"
      class="mb-2 max-w-prose text-sm text-gray-500"
    >
      <slot name="description" />
    </p>

    <slot name="inputBlock" />

    <p
      v-if="$slots.error"
      class="mt-2 max-w-prose text-sm font-semibold text-red-500"
    >
      <slot name="error" />
    </p>
  </div>
</template>
